/**
 * @desc 初始化登录状态
 */
const URL = "/rantion-auth";
import http, { updateResponse } from "@/http";
export function request(params: API.auth.authorizationCode.initLoginState.Params, options?: any) {
  return updateResponse(
    http(URL + `/authCode/loginState`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
